import { FaWhatsapp } from "react-icons/fa";
import { Phone, Clock, Zap, DollarSign, ShieldCheck } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/5567996508622?text=Ol%C3%A1%2C%20preciso%20de%20um%20guincho!";
const TEL_URL = "tel:+5567996508622";

const BADGES = [
  { icon: Clock, text: "Atendimento 24h" },
  { icon: Zap, text: "Chegada rapida" },
  { icon: DollarSign, text: "Preco justo" },
  { icon: ShieldCheck, text: "Profissionais experientes" },
];

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="hero-bg relative min-h-screen flex items-center justify-start"
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/75" />

      {/* Yellow accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#FFD700]" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          {/* Tag */}
          <div className="inline-flex items-center gap-2 bg-[#FFD700] text-black px-4 py-1.5 text-sm font-bold uppercase tracking-wider mb-6 animate-slide-up">
            <Clock className="w-4 h-4" />
            24 Horas | 7 Dias por Semana
          </div>

          {/* Title */}
          <h1
            data-testid="hero-title"
            className="text-4xl sm:text-5xl lg:text-7xl font-black tracking-tighter uppercase leading-[0.95] mb-6 animate-slide-up stagger-1"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            Guincho 24 Horas
            <br />
            em{" "}
            <span className="text-[#FFD700]">Navirai</span>
          </h1>

          {/* Subtitle */}
          <p
            data-testid="hero-subtitle"
            className="text-lg sm:text-xl text-gray-300 leading-relaxed mb-8 max-w-xl animate-slide-up stagger-2"
          >
            Chegamos rapido onde voce estiver. Atendimento imediato para carros,
            motos e veiculos pesados.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10 animate-slide-up stagger-3">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-button"
              className="cta-whatsapp inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20BD5A] text-white text-lg font-bold uppercase tracking-wide px-8 py-4 rounded-sm"
            >
              <FaWhatsapp className="w-6 h-6" />
              Chamar no WhatsApp
            </a>
            <a
              href={TEL_URL}
              data-testid="hero-call-button"
              className="cta-call inline-flex items-center justify-center gap-3 bg-[#FFD700] hover:bg-[#EAB308] text-black text-lg font-bold uppercase tracking-wide px-8 py-4 rounded-sm"
            >
              <Phone className="w-6 h-6" />
              Ligar Agora
            </a>
          </div>

          {/* Badges */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 animate-slide-up stagger-4">
            {BADGES.map(({ icon: Icon, text }) => (
              <div
                key={text}
                className="flex items-center gap-2 bg-black/50 backdrop-blur-sm border border-[#27272A] px-3 py-2.5 rounded-sm"
              >
                <Icon className="w-5 h-5 text-[#FFD700] flex-shrink-0" />
                <span className="text-sm font-medium text-white">{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
